import * as turf from '@turf/turf'

/**
 * 检测多边形是否自相交
 * @param feature {Object} 输入要素
 * @returns {boolean}
 */
export function checkKinks(feature) {
  let featureSet= turf.kinks(feature);
  return featureSet.features.length > 0;
}

/**
 * 生成一种16进制随机颜色
 * @returns {string}
 */
export function getRandomColor(){
  return '#' + Math.floor( Math.random() * 0xffffff ).toString(16);
}

/**
 * 生成多个随机颜色
 * @param {number} count  生成的数量
 * @returns {Array}
 */
export function getRandomColors(count){
  let colors=[];
  for (let i = 0; i < count; i++) {
    colors.push(getRandomColor())
  }
  return colors;
}



// WEBPACK FOOTER //
// ./src/common/CommonFun.js